import { getDecryptedLocalStorageItem } from "./encryptData";

export const refreshStatesFromLocalStorage = (setStateFunctions: Record<string, Function>) => {
    // Map the keys from the local storage to the setState functions
    const keysToSetters = {
        'user_hash': setStateFunctions.setUserHash,
        'user_division': setStateFunctions.setUserDivision,
        'first_name': setStateFunctions.setFirstName,
        'last_name': setStateFunctions.setLastName,
        'environment_hash': setStateFunctions.setEnvironmentHash,
        'type': setStateFunctions.setEnvironmentType,
        'status': setStateFunctions.setEnvironmentStatus,
        'package_features': setStateFunctions.setPackageFeatures,
        'active_features': setStateFunctions.setActiveFeatures,
        'role_features': setStateFunctions.setRoleFeatures,
        'access_to': setStateFunctions.setAccessTo,
        'allowed_features': setStateFunctions.setAllowedFeatures,
        'allowed_rights': setStateFunctions.setAllowedRights,
        'redirect_to': setStateFunctions.setRedirectTo,
        'is_trial': setStateFunctions.setSubscriptionIsTrial,
        'start_date': setStateFunctions.setSubscriptionStartDate,
        'end_date': setStateFunctions.setSubscriptionEndDate,
        'no_payment_method': setStateFunctions.setSubscriptionNoSepaMandate,
        'is_provisional': setStateFunctions.setSubscriptionIsProvisional,
        'view_only_package': setStateFunctions.setPackageIsViewOnly

    };

    // Loop through each storage item to decrypt them and pass them back with the set state function
    Object.entries(keysToSetters).forEach(([key, setStateFunction]) => {
        if (setStateFunction) {
            const decryptedLocalStorageValue = getDecryptedLocalStorageItem(key);
            if (decryptedLocalStorageValue) {
                try {
                    // First try to parse in case it's a JSON field
                    const parsedValue = JSON.parse(decryptedLocalStorageValue);
                    setStateFunction(parsedValue);
                } catch (error) {
                    // In case it's not a JSON field, just take the value
                    setStateFunction(decryptedLocalStorageValue);
                }
            }
        }
    });
};